import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results", "section", "item", "noResults"]
  
  connect() {
    this.allItems = this.itemTargets
    this.allSections = this.sectionTargets
    this.updateResultCount(this.allItems.length, this.allItems.length)
  }
  
  search() {
    const query = this.inputTarget.value.toLowerCase().trim()
    
    if (query === "") {
      this.showAllItems()
      return
    }
    
    let visibleCount = 0
    let totalCount = this.allItems.length
    
    // Process each section
    this.allSections.forEach(section => {
      let sectionHasVisibleItems = false
      const sectionItems = section.querySelectorAll('[data-faq-search-target="item"]')
      
      // Check each item in this section
      sectionItems.forEach(item => {
        const questionElement = item.querySelector('.accordion-header h3')
        const answerElement = item.querySelector('.accordion-content')
        
        if (!questionElement || !answerElement) {
          return
        }
        
        const question = questionElement.textContent.toLowerCase()
        const answer = answerElement.textContent.toLowerCase()
        
        const matches = question.includes(query) || answer.includes(query)
        
        if (matches) {
          item.classList.remove('hidden')
          sectionHasVisibleItems = true
          visibleCount++
        } else {
          item.classList.add('hidden')
        }
      })
      
      // Show/hide section based on whether it has visible items
      if (sectionHasVisibleItems) {
        section.classList.remove('hidden')
      } else {
        section.classList.add('hidden')
      }
    })
    
    this.updateResultCount(visibleCount, totalCount)
    this.toggleNoResults(visibleCount === 0)
  }
  
  clear() {
    this.inputTarget.value = ""
    this.showAllItems()
    this.inputTarget.focus()
  }
  
  showAllItems() {
    this.allItems.forEach(item => {
      item.classList.remove('hidden')
    })

    this.allSections.forEach(section => {
      section.classList.remove('hidden')
    })
    
    this.updateResultCount(this.allItems.length, this.allItems.length)
    this.toggleNoResults(false)
  }
  
  updateResultCount(visible, total) {
    if (this.hasResultsTarget) {
      const currentLocale = document.documentElement.lang || 'hr'
      const isEnglish = currentLocale === 'en'
      
      if (visible === total) {
        this.resultsTarget.textContent = isEnglish 
          ? `Showing all ${total} questions`
          : `Prikazano svih ${total} pitanja`
      } else {
        this.resultsTarget.textContent = isEnglish
          ? `Found ${visible} of ${total} questions`
          : `Pronađeno ${visible} od ${total} pitanja`
      }
    }
  }
  
  toggleNoResults(show) {
    if (this.hasNoResultsTarget) {
      if (show) {
        this.noResultsTarget.classList.remove('hidden')
      } else {
        this.noResultsTarget.classList.add('hidden')
      }
    }
  }
}